import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { Add } from '@mui/icons-material';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import appTheme from '../common/theme/appTheme.json';

interface ProvisioningAddButtonProps extends ButtonProps {
  text: string;
  onClick: () => void;
  sx?: SxProps<Theme>;
}

const ProvisioningAddButton: React.FC<ProvisioningAddButtonProps> = ({ text, onClick, sx, ...props }) => {
  return (
    <Button
      disableRipple
      startIcon={<Add sx={{ fontSize: '24px !important' }} />}
      sx={{
        color: appTheme.secondaryTextLinkColor,
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '24px',
        ':hover': {
          svg: {
            color: appTheme.secondaryTextLinkColor,
          },
        },
        ...sx,
      }}
      onClick={onClick}
      {...props} // Pass down remaining props (including data-testid)
    >
      {text}
    </Button>
  );
};

export default ProvisioningAddButton;
